import React, { Component, Fragment } from "react";
import utils from "../../../../../utils/utils";

export default class FormDespesa extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevProps.categoriaSelecionada !== this.props.categoriaSelecionada) {
            window.location.reload();
        }
    }

    totalAno = (serie) => {
        if(serie) return serie.reduce((acc, atual) => acc + atual, 0);
    }

    render() {
        let { unidade, metas, categoria, indicadoresnome, indicadoresid, metasDaUnidade, formDisabled, metasMensais } = this.props;

        metasDaUnidade = metasDaUnidade && (metasDaUnidade.filter(meta => {
            return meta.categoria.toUpperCase() === categoria.toUpperCase();
        })[0]);

        let despesaCategoria;
        try {
            despesaCategoria = metasMensais && metasMensais.filter(cat => cat.categoria === categoria && cat.unidade === unidade)[0].valores.despesa;
        } catch(erro) {

        }

        return (
            <Fragment>
                <table id={this.props.id} className="text-center table-sm">
                    <thead>
                        <tr>
                            <th colSpan="13">{categoria}</th>
                        </tr>
                        <tr>
                            <th>Indicador</th>
                            <th scope="col">Total</th>
                            <th scope="col">Jan</th>
                            <th scope="col">Fev</th>
                            <th scope="col">Mar</th>
                            <th scope="col">Abr</th>
                            <th scope="col">Mai</th>
                            <th scope="col">Jun</th>
                            <th scope="col">Jul</th>
                            <th scope="col">Ago</th>
                            <th scope="col">Set</th>
                            <th scope="col">Out</th>
                            <th scope="col">Nov</th>
                            <th scope="col">Dez</th>
                        </tr>
                    </thead>
                    <tbody>

                        {indicadoresnome.map((mes, key) => {
                            try {
                                if(indicadoresid[key] === "despesa") return;
                                return (
                                    <Fragment>

                                    {["receita", "despesa"].includes(indicadoresid[key]) ?
                                        <tr key={key}>
                                            <th scope="row" style={{ textTransform: "capitalize" }} >{indicadoresnome[key]}</th>
                                            <td scope="col">{utils.formataValorMoeda(this.totalAno(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]]))}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][0])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][1])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][2])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][3])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][4])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][5])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][6])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][7])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][8])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][9])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][10])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][11])}</td>
                                        </tr>
                                    :
                                        <tr key={key}>
                                            <th scope="row">{indicadoresnome[key]}</th>
                                            <td scope="col">{utils.formataValor(this.totalAno(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]]))}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][0])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][1])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][2])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][3])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][4])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][5])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][6])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][7])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][8])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][9])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][10])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][11])}</td>
                                        </tr>
                                    }

                                    </Fragment>
                                )
                            } catch(erro) {
                            }
                        })}

                        <tr id={categoria}>
                            <th scope="row">Despesa</th>
                            <td scope="col">{despesaCategoria && despesaCategoria.reduce((acc, atual) => acc + atual, 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || "-"}</td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[0]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[1]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[2]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[3]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[4]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[5]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[6]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[7]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[8]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[9]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[10]} disabled={formDisabled} /></td>
                            <td scope="col"><input type="number" step="0.01" className={"despesa"} name={"despesa"} defaultValue={despesaCategoria && despesaCategoria[11]} disabled={formDisabled} /></td>
                        </tr>
                        
                    </tbody>
                </table>
                <input type="hidden" value={categoria} name={"categoria"} />
                <input type="hidden" value={unidade} name={"unidade"} />
                                                
            </Fragment>
        )
    }
}